module.exports = __webpack_public_path__ + "img/MED_VEGETABLES@300x.eca642fa.png";